import { FlexDirection } from "../../../types";

type CollapseBoundary = "desktop" | "tablet";

export type CollapsibleProps = {
  collapseBelow?: CollapseBoundary;
  reverseOnCollapse?: boolean;
};

export function resolveCollapsibleProps({
  collapseBelow,
  reverseOnCollapse
}: CollapsibleProps) {
  const [collapseOnMobile, collapseOnTablet] = getCollapseOnValues(
    collapseBelow
  );

  return {
    flexDirection: [
      getFlexDirection(collapseOnMobile, reverseOnCollapse),
      getFlexDirection(collapseOnTablet, reverseOnCollapse),
      "row" as FlexDirection
    ] as [FlexDirection, FlexDirection, FlexDirection],
    collapseOnMobile,
    collapseOnTablet
  };
}

function getFlexDirection(
  collapse: boolean,
  reverseOnCollapse?: boolean
): FlexDirection {
  if (!collapse) {
    return "row";
  }

  if (reverseOnCollapse) {
    return "column-reverse";
  }

  return "column";
}

function getCollapseOnValues(boundary?: CollapseBoundary) {
  const collapseOnTablet = boundary === "desktop";
  const collapseOnMobile = collapseOnTablet || boundary === "tablet";

  return [collapseOnMobile, collapseOnTablet];
}
